import { StandardNode } from './types';

export type ChildrenMap = Map<number | null, StandardNode[]>;

export function buildChildrenMap(nodes: StandardNode[]): ChildrenMap {
  const map: ChildrenMap = new Map();

  nodes.forEach((node) => {
    const key = node.parent_tag_id;
    const existing = map.get(key);

    if (existing) {
      existing.push(node);
    } else {
      map.set(key, [node]);
    }
  });

  map.forEach(children => children.sort((a, b) => a.position - b.position));

  return map;
}

export function buildParentMap(nodes: StandardNode[]): Map<number, number | null> {
  const map = new Map<number, number | null>();
  nodes.forEach((node) => { map.set(node.id, node.parent_tag_id); });
  return map;
}
